// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__n+xgi","modal":"Modal_modal__l8Mh4","slide-down":"Modal_slide-down__HMdhO"};